module.exports = __webpack_public_path__ + "img/jackpot_1-01.147fac65.png";